import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function LinkExternalAccounts({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M18.5997 6.06701C17.0376 4.50492 14.5049 4.50492 12.9428 6.06702L10.1144 8.89544C8.55229 10.4575 8.55229 12.9902 10.1144 14.5523L11.0572 15.4951L12 14.5523L11.0572 13.6095C10.0158 12.5681 10.0158 10.8796 11.0572 9.83825L13.8856 7.00982C14.927 5.96843 16.6155 5.96843 17.6569 7.00982C18.6983 8.05122 18.6983 9.73966 17.6569 10.7811L15.4627 12.9753C15.597 13.5704 15.6214 14.1853 15.5359 14.7877L18.5997 11.7239C20.1618 10.1618 20.1618 7.62911 18.5997 6.06701Z"
        fill={iconColor}
      />
      <Path
        d="M7.91507 11.0948L5.40037 13.6095C3.83827 15.1716 3.83827 17.7042 5.40037 19.2663C6.96246 20.8284 9.49512 20.8284 11.0572 19.2663L13.4142 16.9093C14.9763 15.3472 14.9763 12.8145 13.4142 11.2524L12.9428 10.781L12 11.7238L12.4714 12.1952C13.5128 13.2366 13.5128 14.9251 12.4714 15.9665L10.1144 18.3235C9.07301 19.3649 7.38457 19.3649 6.34317 18.3235C5.30178 17.2821 5.30178 15.5937 6.34317 14.5523L8.01029 12.8852C7.87263 12.298 7.84089 11.691 7.91507 11.0948ZM9.1923 10.3303C8.9998 10.8494 8.91868 11.4005 8.94894 11.9465L8.94901 11.9464C8.91877 11.4005 8.99989 10.8495 9.19238 10.3304L9.1923 10.3303Z"
        fill={iconColor}
      />
    </Svg>
  );
}
